var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoKingBedNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.932 14.992v3.23H6.607V14.986a11.16 11.16 0 0 1 3.109-.452 11.738 11.738 0 0 1 3.217.459m4.652 3.23V14.986a11.16 11.16 0 0 1 3.109-.452 11.761 11.761 0 0 1 3.217.459v3.23zM1.734 19.979H28.785v8.327H1.734zM15.093 8.927A39.049 39.049 0 0 0 1.94 11.288v6.934H0V32.314h1.734l.306-2.252H28.478l.305 2.252h1.733V18.222h-1.94V11.28A41.327 41.327 0 0 0 15.093 8.927ZM13.77 4.245l1.48-1.762 1.48 1.762 1.3-.652L17.68 5.569H12.82l-.353-1.976ZM15.25 0 13.364 2.249 10.345.739l1.149 6.438H19L20.154.739l-3.018 1.51Zm-.584 13.706a14.723 14.723 0 0 0-4.95-.924 13.907 13.907 0 0 0-4.843.932v4.506h-1.2V12.546a36.5 36.5 0 0 1 11.42-1.869 38.55 38.55 0 0 1 11.75 1.876v5.669h-1.2V13.708l-.6-.2a13.658 13.658 0 0 0-4.351-.725 13.907 13.907 0 0 0-4.843.932v4.506H14.667Z",
    fill: "#1d1d1f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoKingBedNew);
export default __webpack_public_path__ + "static/media/icoKingBedNew.be2778cf86d95d0917340902c9a43c66.svg";
export { ForwardRef as ReactComponent };